import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=d6bdb86c"
import script from "./CustomToggle.vue?vue&type=script&lang=js"
export * from "./CustomToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports